import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import SEOMeta from '../components/SEOMeta';
import { getRouteSEO } from '../constants/routeSEO';
import Footer from './Footer';

interface PublicLayoutProps {
  children?: React.ReactNode;
}

/** Paths where the page sets its own Helmet; skip layout SEO to avoid title conflicts. */
const SELF_SEO_PATHS = ['/', '/about', '/gdpr', '/tools', '/blog'];

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const isSelfSEO = SELF_SEO_PATHS.some(
    (p) => pathname === p || (p !== '/' && pathname.startsWith(p + '/'))
  );
  const routeMeta = !isSelfSEO ? getRouteSEO(pathname) : undefined;
  return (
    <div className="min-h-screen">
      <SEOMeta
        {...(routeMeta && { title: routeMeta.title, description: routeMeta.description })}
      />
      {children || <Outlet />}
      <Footer />
    </div>
  );
};

export default PublicLayout;

